import { connect } from 'react-redux';
import Dashboard from '../../components/dashboard';
import {
    fetchDashboardResultsThunk,
    fetchDashboardCostsThunk,
    eventStatusBreakdownThunk,
    taskDueThunk
} from '../../actions';

import {
    getDashboardETResultsNumber,
    getDashboardCostsNumber,
    getEventStatusBreakDown,
    getTasksDueTotal,
    getTasksDueLoading
} from '../../reducers';

const mapStateToProps = state => ({
    userInfo: state.data.userInfo,
    dashboardETResultsNumber: getDashboardETResultsNumber(state),
    dashboardCosts: getDashboardCostsNumber(state),
    getEventStatusBreakDown: getEventStatusBreakDown(state),
    getTasksDueTotal: getTasksDueTotal(state),
    getTasksDueLoading: getTasksDueLoading(state)
});

const mapDispatchToProps = dispatch => ({
    fetchDashboardETResults: (filters, filtertype) =>
        dispatch(fetchDashboardResultsThunk(filters, filtertype)),
    fetchDashboardCostsResults: filters =>
        dispatch(fetchDashboardCostsThunk(filters)),
    eventStatusBreakdownThunk: () => dispatch(eventStatusBreakdownThunk()),
    taskDueThunk: () => dispatch(taskDueThunk())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/dashboard/index.js